import {matchAllWords} from '../../../utils/string-helpers';

export class SdmGame {
    constructor(private _sdmGameInfo: any) {
        this._searchString = `${this.title} ${this.gameType}`;
    }

    private readonly _searchString: string;
    get gameType(): number {
        return this._sdmGameInfo.GameType;
    }

    get title(): string {
        return this._sdmGameInfo.Title || '';
    }

    get vendorName(): string {
        return this._sdmGameInfo.VendorName || '';
    }

    get companyName(): string {
        return this._sdmGameInfo.CompanyName || '';
    }

    get icon(): string {
        return this._sdmGameInfo.Images.icon;
    }

    combineVendorAndCompanyName(): string {
        if(this.vendorName.toLowerCase() === this.companyName.toLowerCase()) {
            return this.companyName;
        }

        return `${this.vendorName} - ${this.companyName}`;
    }

    isAllWordsMatch(words: RegExp[]): boolean {
        return matchAllWords(this._searchString, words);
    }
}